<template>
  <div style="width: 100%;position:relative;">

    <div style="height: 80px;"></div>
    <div style="width: 100%;height: 80px;display: flex;justify-content: center;" :style="{
    background: 'rgba(255, 255, 255, ' + percent + ')',
    boxShadow: percent === 1 ? '0px 8px 7px 0px rgba(183,208,249,0.45)' : ''
  }" class="sticky">
      <div class="zy-container flex flex-center">
        <div class="flex flex-between flex-center" style="height: 56px;flex-grow: 1;">
          <div class="flex flex-center ">
            <router-link to="/">
              <img alt="logo" :src="dataStyle.logo" class="logo">
            </router-link>
            <div class="nav">
              <router-link v-for="nav in navs" :key="nav.name" :to="nav.path">
                <div class="nav-item" :style="{
                color: currentPath === nav.path ? dataStyle.choose_cate_color : dataStyle.un_choose_cate_color
              }">
                  {{ nav.name }}
                  <div v-if="currentPath === nav.path" class="line" :style="{
                backgroundColor: dataStyle.pointer_color
              }"></div>
                </div>

              </router-link>
            </div>
          </div>
          <a-space class="flex flex-center" :size="20">
            <template v-if="userInfo">
              <router-link to="/business/goods-manager" v-if="userInfo.is_store=='1'&&dataStyle.business_btn_data&&dataStyle.business_btn_data.is_show=='1'">
                <div :style="{
                color: dataStyle.business_btn_data.title_color
              }" class="window">
                  <img :src="dataStyle.business_btn_data.img" style="width: 24px;height: 24px;object-fit: contain;"/>
                  {{ dataStyle.business_btn_data.title }}
                </div>
              </router-link>

              <router-link to="/setting/mine-window" v-if="dataStyle.window_btn_data && dataStyle.window_btn_data.is_show=='1'">
                <div :style="{
                color: dataStyle.window_btn_data.title_color
              }" class="window">
                  <img :src="dataStyle.window_btn_data.img" style="width: 24px;height: 24px;object-fit: contain;"/>
                  {{ dataStyle.window_btn_data.title }}
                </div>
              </router-link>

              <router-link to="/setting/mine-collection">
                <div class="login" :style="{
                color: dataStyle.mylike_btn_data.title_color
              }">
                  <img :src="dataStyle.mylike_btn_data.img"
                       style="width: 14px;height: 14px;object-fit: contain;margin-right: 4px;"/>
                  {{ dataStyle.mylike_btn_data.title }}
                </div>
              </router-link>
              <a-popover placement="bottomRight">
                <template slot="content">
                  <div style="padding: 10px;display:flex;align-items: center;">
                    <img :src="userInfo.avatar" style="width: 30px;height: 30px;border-radius: 20px;"/>
                    <div style="margin-left: 10px;margin-right: 10px;width: 150px;">
                      <div style="color: black;font-size: 12px;">{{ userInfo.nickname }}</div>
                      <div style="color: #7f7f7f;font-size: 12px;">ID:{{ userInfo.user_id }}</div>
                    </div>
                    <a style="color: #7f7f7f; font-size: 12px;" @click="logout">退出</a>
                  </div>
                  <router-link to="/setting/mine-auth">
                    <div style="padding: 10px;display:flex;align-items: center;">
                      <img src="@/assets/images/setting/menus/mine-douyin.png" style="width: 18px;height: 18px;"/>
                      <div style="margin-left: 10px;margin-right: 10px;color: black; font-size: 14px;">
                        我的达人号
                      </div>
                    </div>
                  </router-link>

                </template>
                <img :src="userInfo.avatar" class="avatar"/>
              </a-popover>
            </template>
            <router-link v-else to="/login">
              <div class="login">登录/注册</div>
            </router-link>
          </a-space>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex'

const {mapGetters, mapActions} = createNamespacedHelpers('user')

export default {
  name: "ZyHeader",
  props: {
    mod: Object
  },
  computed: {
    ...mapGetters({userInfo: 'getUserInfo'}),
    dataStyle() {
      return this.mod && this.mod.data ? JSON.parse(this.mod.data) : undefined
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to.path, from);
        this.currentPath = to.path
      },
      immediate: true
    }
  },
  data() {
    return {
      percent: 0,
      currentPath: '',
      navs: [
        {name: '首页', path: '/home'},
        {name: '选品库', path: '/search'},
        // {name: '直播切片', path: ''}
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      logout: 'logout'
    }),
    handleScroll() {
      const hei = 80;
      //或者使用document.querySelector('.class或者#id').scrollTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      let percent = this.scroll / hei
      percent = percent < 0 ? 0 : percent
      percent = percent > 1 ? 1 : percent
      this.percent = percent
    },
  },
//销毁,否则跳到别的路由还是会出现
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">

.flex {
  display: flex;
}

.flex-between {
  justify-content: space-between;
}

.flex-center {
  align-items: center;
}

.sticky {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
}

.cnt {
  width: 100vw;
  display: flex;
  flex-direction: column;
  //justify-content: center;
  align-items: center;
}

.logo {
  height: 56px;
  cursor: pointer;
}

.header {
  display: flex;
}

.nav {
  display: flex;
  margin-left: 22px;
  margin-right: 22px;

  .nav-item {
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    padding: 8px 22px;
    cursor: pointer;
    position: relative;

    .line {
      position: absolute;
      width: 12px;
      height: 3px;
      bottom: 4px;
      left: calc(50% - 6px);
      background-color: #9718FF;
    }
  }
}

@media screen and (max-width: 768px) {
  .nav {
    display: none;
  }
}

.login {
  font-size: 16px;
  color: #0052FF;
  line-height: 38px;
  //height: 38px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 20px;
  border: 2px solid #00AFFF;
  display: flex;
  align-items: center;
}

.window {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
}

.avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 20px;
  border: 2px solid white;
  cursor: pointer;
}

.avatar:hover {
  box-shadow: 0px 0px 23px 0px rgba(75, 75, 75, 0.31);
}

</style>
